import { Box } from "@mui/material";
import CustomButton from "../../../../UIElements/CustomButton";
import "../../../../components-styles.scss";
import "../../../profil-styles.scss";
import CancelModalButton from "../../../../UIElements/CustomModal/CancelModalButton";
import EstablishmentContactFormWrapper from "../../../../Common/EstablishmentContactFormWrapper";
import { EditContactType } from "../../../../../types";

type EditAdressFormProps = {
    profilId: string;
    onSubmit: (data: any) => void;
    defaultValue: {
        contacts: EditContactType[];
    };
};

export default function EditManagerForm({
    onSubmit,
    defaultValue,
    profilId,
}: EditAdressFormProps) {
    const { contacts } = defaultValue;
    return (
        <Box className="profil-form-root">
            <EstablishmentContactFormWrapper
                contacts={contacts}
                profilId={profilId}
                jobTitle={"Le dirigeant"}
                onSubmit={onSubmit}
                className="profil-form-container"
                formActionComponents={{
                    submit: (
                        <CustomButton
                            type="submit"
                            label="Enregister"
                            customsx={{
                                width: "100%",
                            }}
                        />
                    ),
                    cancel: (
                        <CancelModalButton
                            customsx={{
                                width: "100%",
                            }}
                        />
                    ),
                }}
                classes={{
                    contactFormElements: {
                        outlinedinputsx: {
                            border: "2px solid  #E3E6E8",
                        },
                    },
                }}
            />
        </Box>
    );
}
